export const formatBRL = (input) => {
    // Verificar se o input é válido
    if (input === null || input === undefined) {
        return 'R$ 0,00';
    }
    
    // Converter para string se for número
    const inputStr = typeof input === 'number' ? input.toString() : String(input);
    
    // Verificar se é uma string válida
    if (typeof inputStr !== 'string' || inputStr.trim() === '') {
        return 'R$ 0,00';
    }
    
    let cleaned = inputStr.replace(/\D/g, '');
    if (cleaned.length === 0) return 'R$ 0,00';
    let decimals = cleaned.slice(-2).padStart(2, '0');
    let integerPart = cleaned.length > 2 ? cleaned.slice(0, -2) : '0';
    integerPart = integerPart.replace(/^0+/, '') || '0';
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `R$ ${integerPart},${decimals}`;
};